/* eslint-disable */

import { sm2, sm4 } from 'sm-crypto'

let sm2PublicKey =
  '047ad81d3d6fcf1c36cf4b64429ee1d1bfb5dc8e9ec6cb6c1941d44cbe616e0d0799179f017d7fe0173ae68b6107a36d14f72cb87ff66fd0974d5bfd5ac47d4df6'

function getRandomBytes(len) {
  const bytes = new Uint8Array(len)
  if (window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < len; i++) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }
  return bytes
}

function bytesToHex(bytes) {
  return Array.prototype.map
    .call(bytes, (b) => ('00' + b.toString(16)).slice(-2))
    .join('')
}

function bytesToBase64(bytes) {
  let binary = ''
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary)
}

function base64ToBytes(b64) {
  const binary = atob(b64)
  const len = binary.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes
}
function base64ToHex(b64) {
  return Array.from(base64ToBytes(b64))
    .map(b => ('00' + b.toString(16)).slice(-2))
    .join('')
}


function hexToBytes(hex) {
  const clean = hex.replace(/^0x/, '')
  const len = clean.length
  const bytes = new Uint8Array(len / 2)
  for (let i = 0; i < len; i += 2) {
    bytes[i / 2] = parseInt(clean.substr(i, 2), 16)
  }
  return bytes
}

function getSessionKeyAndIv() {
  return {
    key: getRandomBytes(16),
    iv: getRandomBytes(16)
  }
}

function getSm2PublicKey() {
  if (sm2PublicKey) return sm2PublicKey
  try {
    const stored = sessionStorage.getItem('sm2PublicKey')
    if (stored) {
      sm2PublicKey = stored
    }
  } catch (e) {
    console.log(e)
  }
  return sm2PublicKey
}

function encryptValueWithSm4(value, keyBytes, ivBytes) {
  if (value === undefined || value === null) return null
  if (typeof value !== 'string') return null
  const plain = value
  const keyHex = bytesToHex(keyBytes)
  const ivHex = bytesToHex(ivBytes)
  const cipherHex = sm4.encrypt(plain, keyHex, {
    mode: 'cbc',
    iv: ivHex
  })
  if (cipherHex === undefined || cipherHex === null) return null
  const cipherBytes = hexToBytes(String(cipherHex))
  return bytesToBase64(cipherBytes)
}

function decryptValueWithSm4(value, keyBytes, ivBytes) {
  if (value === undefined || value === null) return null
  if (typeof value !== 'string') return null
  const keyHex = bytesToHex(keyBytes)
  const ivHex = bytesToHex(ivBytes)
  const cipherHex = base64ToHex(value.trim())
  const plain = sm4.decrypt(cipherHex, keyHex, {
    mode: 'cbc',
    iv: ivHex,
  })
  if (!plain) return null
  return plain
}

function resolveKeyForTarget(target, rawKey, normalizedKey) {
  if (!target || typeof target !== 'object') return normalizedKey
  if (Object.prototype.hasOwnProperty.call(target, rawKey)) return rawKey
  return normalizedKey
}

function createRequestCryptoLogger(config) {
  const logs = []
  const url = config && config.url ? config.url : '(unknown-url)'
  return {
    hit(path, status, detail) {
      logs.push({ path, status, detail })
    },
    flush() {
      if (!logs.length) return
      console.groupCollapsed(`[request-crypto] ${url} 字段处理明细`)
      logs.forEach((item) => {
        console.log(
          `[request-crypto] path=${item.path} status=${item.status} detail=${item.detail}`
        )
      })
      console.groupEnd()
    }
  }
}

function joinPath(basePath, keySegment) {
  if (!basePath) return keySegment
  return `${basePath}.${keySegment}`
}

function applyCryptoTree(target, tree, transformFn, currentPath = '') {
  if (!target || !tree) return
  if (typeof tree !== 'object') return

  Object.keys(tree).forEach((rawKey) => {
    const rule = tree[rawKey]
    const isArrayWildcard = rawKey.endsWith('[]')
    const normalizedKey = isArrayWildcard ? rawKey.slice(0, -2) : rawKey
    const key = resolveKeyForTarget(target, rawKey, normalizedKey)
    const value = target[key]
    const fieldPath = joinPath(currentPath, key)

    if (rule === 1) {
      if (isArrayWildcard) {
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            const next = transformFn(value[i], `${fieldPath}[${i}]`)
            if (next !== null) value[i] = next
          }
        } else {
          transformFn(undefined, `${fieldPath}[]`)
        }
      } else {
        const next = transformFn(value, fieldPath)
        if (next !== null) target[key] = next
      }
      return
    }

    if (rule && typeof rule === 'object') {
      if (isArrayWildcard) {
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            applyCryptoTree(value[i], rule, transformFn, `${fieldPath}[${i}]`)
          }
        } else {
          transformFn(undefined, `${fieldPath}[]`)
        }
      } else {
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            applyCryptoTree(value[i], rule, transformFn, `${fieldPath}[${i}]`)
          }
        } else {
          applyCryptoTree(value, rule, transformFn, fieldPath)
        }
      }
    }
  })
}

function setPathValue(obj, path, transformFn) {
  if (!obj || !path) return
  const parts = path.split('.')
  function helper(target, idx, basePath) {
    if (!target) return
    const part = parts[idx]
    const isArrayWildcard = part.endsWith('[]')
    const normalizedKey = isArrayWildcard ? part.slice(0, -2) : part
    const key = resolveKeyForTarget(target, part, normalizedKey)
    const fieldPath = joinPath(basePath, key)
    if (idx === parts.length - 1) {
      if (isArrayWildcard) {
        const arr = target[key]
        if (Array.isArray(arr)) {
          for (let i = 0; i < arr.length; i++) {
            const next = transformFn(arr[i], `${fieldPath}[${i}]`)
            if (next !== null) {
              arr[i] = next
            }
          }
        } else {
          transformFn(undefined, `${fieldPath}[]`)
        }
      } else {
        const next = transformFn(target[key], fieldPath)
        if (next !== null) {
          target[key] = next
        }
      }
      return
    }
    if (isArrayWildcard) {
      const arr = target[key]
      if (Array.isArray(arr)) {
        for (let i = 0; i < arr.length; i++) {
          helper(arr[i], idx + 1, `${fieldPath}[${i}]`)
        }
      } else {
        transformFn(undefined, `${fieldPath}[]`)
      }
    } else {
      helper(target[key], idx + 1, fieldPath)
    }
  }
  helper(obj, 0, '')
}

export function applyRequestCrypto(config) {
  const vconfig = config.vconfig || {}
  const cryptoFields =
    vconfig.cryptoFields !== undefined ? vconfig.cryptoFields : config.cryptoFields
  const needCryptoResponse =
    vconfig.needCryptoResponse !== undefined
      ? vconfig.needCryptoResponse
      : config.needCryptoResponse
  const requestCryptoLogger = createRequestCryptoLogger(config)
  const hasCryptoFields =
    (Array.isArray(cryptoFields) && cryptoFields.length > 0) ||
    (!!cryptoFields &&
      typeof cryptoFields === 'object' &&
      !Array.isArray(cryptoFields) &&
      Object.keys(cryptoFields).length > 0)
  if (!hasCryptoFields && !needCryptoResponse) {
    return config
  }

  const method = (config.method || 'GET').toUpperCase()
  let target = null
  let restoreJsonStringData = false
  if (method === 'GET') {
    if (!config.params) config.params = {}
    target = config.params
  } else {
    if (!config.data) config.data = {}
    target = config.data
    if (typeof target === 'string') {
      const text = target.trim()
      if (
        (text.startsWith('{') && text.endsWith('}')) ||
        (text.startsWith('[') && text.endsWith(']'))
      ) {
        try {
          target = JSON.parse(text)
          config.data = target
          restoreJsonStringData = true
        } catch (e) {
          console.warn('request crypto json parse skipped', e)
        }
      }
    }
  }

  const { key, iv } = getSessionKeyAndIv()
  const encryptFn = (val, fieldPath) => {
    if (val === undefined || val === null) {
      requestCryptoLogger.hit(fieldPath, 'skip', 'value is null/undefined')
      return null
    }
    if (typeof val !== 'string') {
      requestCryptoLogger.hit(
        fieldPath,
        'skip',
        `value type is ${typeof val}, only string can be encrypted`
      )
      return null
    }
    if (val.trim() === '') {
      requestCryptoLogger.hit(fieldPath, 'skip', 'value is empty string')
      return null
    }
    const next = encryptValueWithSm4(val, key, iv)
    if (next === null) {
      requestCryptoLogger.hit(fieldPath, 'skip', 'sm4 returned null')
      return null
    }
    requestCryptoLogger.hit(fieldPath, 'encrypted', 'ok')
    return next
  }

  try {
    if (hasCryptoFields) {
      if (Array.isArray(cryptoFields)) {
        cryptoFields.forEach((fieldPath) => {
          setPathValue(target, fieldPath, encryptFn)
        })
      } else {
        applyCryptoTree(target, cryptoFields, encryptFn)
      }
    }


    const strArr = []
    const keyB64 = bytesToBase64(key)
    const ivB64 = bytesToBase64(iv)

    strArr.push(keyB64, ivB64)

    if (hasCryptoFields) {
      const fieldsJson = JSON.stringify(cryptoFields)
      const fieldsBytes = new TextEncoder().encode(fieldsJson)
      const fieldsB64 = bytesToBase64(fieldsBytes)
      strArr.push(fieldsB64)
    }

    const secPlain = strArr.join(';')
    const pubKey = getSm2PublicKey()
    if (!pubKey) {
      throw new Error('sm2 public key not found')
    }
    const sm2CipherHex = sm2.doEncrypt(secPlain, pubKey, 1)
    const sm2CipherBytes = hexToBytes(sm2CipherHex)
    const secHeader = bytesToBase64(sm2CipherBytes)
    if (!config.headers) config.headers = {}
    config.headers['X-SEC'] = secHeader
    config._secCrypto = {
      key,
      iv
    }
  } catch (e) {
    console.error('request crypto error', e)
    return Promise.reject(e)
  }

  if (restoreJsonStringData) {
    try {
      config.data = JSON.stringify(target)
    } catch (e) {
      console.warn('request crypto json stringify skipped', e)
    }
  }
  requestCryptoLogger.flush()

  return config
}

export function applyResponseCrypto(response) {
  if (!response || !response.headers) return response
  const header = response.headers['x-sec-r'] || response.headers['X-SEC-R']
  if (!header) return response

  let fields = null
  try {
    const bytes = base64ToBytes(header)
    const jsonStr = new TextDecoder().decode(bytes)
    const parsed = JSON.parse(jsonStr)
    if (
      Array.isArray(parsed) ||
      (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0)
    ) {
      fields = parsed
    }
  } catch (e) {
    console.error('response crypto fields parse error', e)
    return response
  }

  if (
    !fields ||
    (Array.isArray(fields) && fields.length === 0) ||
    (!Array.isArray(fields) &&
      typeof fields === 'object' &&
      Object.keys(fields).length === 0)
  ) {
    return response
  }

  const cryptoInfo = response.config && response.config._secCrypto
  if (!cryptoInfo || !cryptoInfo.key || !cryptoInfo.iv) {
    console.warn('response crypto missing key/iv on config')
    return response
  }

  const target = response.data
  if (!target) return response

  const decryptFn = (val) =>
    decryptValueWithSm4(val, cryptoInfo.key, cryptoInfo.iv)

  try {
    if (Array.isArray(fields)) {
      fields.forEach((path) => {
        setPathValue(target, path, decryptFn)
      })
    } else {
      applyCryptoTree(target, fields, decryptFn)
    }
  } catch (e) {
    console.error('response crypto error', e)
    return response
  }

  return response
}
